/* Lace & Puck garment switcher. Works with linked Shopify products; no hardcoded prices. */
(function () {
  'use strict';
  function kinds(card){return Array.from(card.querySelectorAll('template[data-lp-template]')).map(function(t){return t.dataset.lpTemplate;});}
  function change(card, kind) {
    var options = Array.from(card.querySelectorAll('template[data-lp-template]'));
    var found = options.find(function(t){return t.dataset.lpTemplate === kind;});
    if (!found) return false;
    if (card.dataset.lpSelected === kind) return true;
    var content = found.content.firstElementChild;
    if (!content) return false;
    var stage = card.querySelector('[data-lp-current]');
    if (!stage) return false;
    stage.replaceChildren(content.cloneNode(true));
    card.dataset.lpSelected = kind;
    var used = {};
    card.querySelectorAll('[data-lp-switch]').forEach(function(el) {
      var k = el.dataset.lpSwitch;
      var already = used[k];
      used[k] = true;
      el.hidden = (k === kind || already);
      if (el.hidden) el.setAttribute('data-lp-selected', '');
      else el.removeAttribute('data-lp-selected');
    });
    return true;
  }
  /* Homepage tabs: choose matching design cards first, then show 16 per page.
     Other collection views keep their existing Shopify pagination. */
  function paginationControl(scope) {
    var grid = scope.querySelector('.product-grid');
    if (!grid) return null;
    var nav = scope.querySelector('[data-lp-pagination]');
    if (!nav) {
      nav = document.createElement('nav');
      nav.className = 'lp-pagination';
      nav.setAttribute('data-lp-pagination', '');
      nav.setAttribute('aria-label', 'Design pages');
      grid.insertAdjacentElement('afterend', nav);
    }
    return nav;
  }
  function drawPages(scope, total, perPage, current) {
    var nav = paginationControl(scope);
    if (!nav) return;
    var pageCount = Math.ceil(total / perPage);
    nav.replaceChildren();
    nav.hidden = pageCount <= 1;
    if (pageCount <= 1) return;
    function addButton(label, page, selected, disabled) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'lp-pagination__button';
      button.textContent = label;
      button.setAttribute('data-lp-page', String(page));
      button.disabled = disabled;
      if (selected) button.setAttribute('aria-current', 'page');
      nav.appendChild(button);
    }
    addButton('Previous', current - 1, false, current === 1);
    for (var i = 1; i <= pageCount; i++) {
      addButton(String(i), i, i === current, false);
    }
    addButton('Next', current + 1, false, current === pageCount);
    var summary = document.createElement('span');
    summary.className = 'lp-pagination__summary';
    var from = (current - 1) * perPage + 1;
    var to = Math.min(total, current * perPage);
    summary.textContent = 'Showing ' + from + '-' + to + ' of ' + total + ' designs';
    nav.appendChild(summary);
  }
  /* Deduplicate design families when linked_garments or design_group is set. */
  function eligibleGroupedCards(cards) {
    var parents = new Map();
    function find(id) {
      if (!parents.has(id)) parents.set(id, id);
      var current = parents.get(id);
      if (current !== id) {
        current = find(current);
        parents.set(id, current);
      }
      return current;
    }
    function link(a, b) {
      if (!a || !b) return;
      var pa = find(a);
      var pb = find(b);
      if (pa !== pb) parents.set(pa, pb);
    }
    var firstByDesign = new Map();
    cards.forEach(function(card) {
      var id = card.dataset.lpId;
      if (!id) return;
      find(id);
      (card.dataset.lpRelated || '').split(',').forEach(function(related) {
        link(id, related.trim());
      });
      var group = (card.dataset.lpDesign || '').trim();
      if (group) {
        if (firstByDesign.has(group)) link(id, firstByDesign.get(group));
        else firstByDesign.set(group, id);
      }
    });
    var winners = new Map();
    cards.forEach(function(card, index) {
      var id = card.dataset.lpId || 'unique-' + index;
      var group = find(id);
      var price = Number(card.dataset.lpStartPrice);
      if (!Number.isFinite(price) || price <= 0) price = Number.MAX_SAFE_INTEGER;
      var styles = new Set(kinds(card)).size;
      var previous = winners.get(group);
      if (!previous || price < previous.price || (price === previous.price && styles > previous.styles)) {
        winners.set(group,{card:card,price:price,styles:styles});
      }
    });
    var selected = new Set(Array.from(winners.values()).map(function(w){return w.card;}));
    return cards.filter(function(card){return selected.has(card);});

  }
  function applyGlobal(scope) {
    var cards = Array.from(scope.querySelectorAll('[data-lp-card]'));
    if (!cards.length) return;
    cards.forEach(function(card) {
      var count = new Set(kinds(card)).size;
      var label = card.querySelector('[data-lp-style-count]');
      if (label) label.textContent = count === 1 ? '1 style' : count + ' styles';
      var details = card.querySelector('details.lp-card__alternates');
      if (details) {
        details.hidden = count < 2;
        if (count < 2) details.open = false;
      }
      if (!card.dataset.lpSelected && card.dataset.lpInitialKind) {
        var kind = card.dataset.lpInitialKind;
        card.dataset.lpSelected = kind;
        var used = {};
        card.querySelectorAll('[data-lp-switch]').forEach(function(el) {
          var k = el.dataset.lpSwitch, duplicate = used[k];
          used[k] = true;
          el.hidden = (k === kind || duplicate);
          if (el.hidden) el.setAttribute('data-lp-selected','');
          else el.removeAttribute('data-lp-selected');
        });
      }
    });
    var perPage = Math.max(1,parseInt(scope.dataset.lpPageSize,10)||16);
    var eligible = eligibleGroupedCards(cards);
    if (scope.dataset.lpShopAll === 'true') {
      scope.querySelectorAll('.products-count-wrapper span[title]').forEach(function(label) {
        label.textContent = eligible.length + (eligible.length === 1 ? ' design' : ' designs');
        label.setAttribute('title', 'Unique design cards');
      });
    }
    if (!scope._lpRandomKeys) scope._lpRandomKeys = new Map();
    eligible.forEach(function(card) {
      if (!scope._lpRandomKeys.has(card)) scope._lpRandomKeys.set(card,Math.random());
    });
    eligible.sort(function(a,b){return scope._lpRandomKeys.get(a)-scope._lpRandomKeys.get(b);});
    var maxPage = Math.max(1,Math.ceil(eligible.length/perPage));
    var page = Math.min(maxPage,Math.max(1,parseInt(scope.dataset.lpCurrentPage,10)||1));
    scope.dataset.lpCurrentPage = String(page);
    var selected = new Set(eligible.slice((page-1)*perPage,page*perPage));
    cards.forEach(function(card) {
      var item = card.closest('.product-grid__item');
      var show = selected.has(card);
      if (!show) {
        var expanded = card.querySelector('details.lp-card__alternates');
        if (expanded) expanded.open = false;
      }
      if (item) {
        item.hidden = !show;
        if (show) item.removeAttribute('data-lp-hidden');
        else item.setAttribute('data-lp-hidden','');
      }
    });
    var grid = scope.querySelector('.product-grid');
    // Shuffle actual DOM order so keyboard and visual navigation agree.
    if (grid) {
      if (scope._lpGridObserver) scope._lpGridObserver.disconnect();
      eligible.forEach(function(card) {
        var item = card.closest('.product-grid__item');
        if (item && item.parentElement === grid) grid.appendChild(item);
      });
      cards.forEach(function(card) {
        if (eligible.indexOf(card) !== -1) return;
        var item = card.closest('.product-grid__item');
        if (item && item.parentElement === grid) grid.appendChild(item);
      });
      if (scope._lpGridObserver) scope._lpGridObserver.observe(grid,{childList:true,subtree:false});
    }
    var message = scope.querySelector('[data-lp-no-results]');
    if (!message && grid) {
      message = document.createElement('p');
      message.className = 'lp-no-results';
      message.setAttribute('data-lp-no-results','');
      message.textContent = 'No designs available yet.';
      grid.insertAdjacentElement('afterend',message);
    }
    if (message) message.hidden = eligible.length > 0;
    drawPages(scope,eligible.length,perPage,page);
  }
  function setup(scope) {
    if (!scope || scope.dataset.lpInitialized === '1') return;
    scope.dataset.lpInitialized = '1';
    scope.addEventListener('click', function(event) {
      var pageButton = event.target.closest('[data-lp-page]');
      if (pageButton && scope.contains(pageButton) && !pageButton.disabled) {
        event.preventDefault();
        scope.dataset.lpCurrentPage = pageButton.dataset.lpPage;
        applyGlobal(scope);
        var grid = scope.querySelector('.product-grid');
        if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      var choice = event.target.closest('[data-lp-switch]');
      if (choice && scope.contains(choice)) {
        var card = choice.closest('[data-lp-card]');
        if (card && change(card, choice.dataset.lpSwitch)) event.preventDefault();
        return;
      }
      var swatch = event.target.closest('[data-lp-swatch]');
      if (swatch && scope.contains(swatch)) {
        var panel = swatch.closest('[data-lp-panel]');
        var newImage = swatch.dataset.lpSwatchImage;
        if (!newImage) {
          var url = swatch.dataset.lpSwatchUrl;
          if (url) window.location.assign(url);
          return;
        }
        var image = panel && panel.querySelector('.lp-panel__image');
        if (image) {
          image.src = newImage;
          image.removeAttribute('srcset');
        }
        var price = panel && panel.querySelector('[data-lp-price]');
        if (price && swatch.dataset.lpSwatchPrice) price.textContent = swatch.dataset.lpSwatchPrice;
        var links = panel && panel.querySelectorAll('a[href]');
        if (links && swatch.dataset.lpSwatchUrl) links.forEach(function(a){a.href = swatch.dataset.lpSwatchUrl;});
        var moreLink = panel && panel.querySelector('[data-lp-more-colors]');
        if (moreLink && swatch.dataset.lpSwatchUrl) moreLink.href = swatch.dataset.lpSwatchUrl;
        panel.querySelectorAll('[data-lp-swatch]').forEach(function(b){b.setAttribute('aria-pressed', String(b === swatch));});
      }
    });
    watchGrid(scope);
    applyGlobal(scope);
  }
  function watchGrid(scope) {
    var grid = scope.querySelector('.product-grid');
    if (grid === scope._lpObservedGrid) return;
    if (scope._lpGridObserver) scope._lpGridObserver.disconnect();
    scope._lpObservedGrid = grid;
    if (!grid) return;
    var observer = new MutationObserver(function(mutations) {
      if (mutations.some(function(m){return Array.from(m.addedNodes).some(function(n){return n.nodeType === 1 && (n.matches && n.matches('.product-grid__item') || n.querySelector && n.querySelector('[data-lp-card]'));});})) applyGlobal(scope);
    });
    observer.observe(grid,{childList:true,subtree:false});
    scope._lpGridObserver = observer;
  }
  function init(){
    document.querySelectorAll('[data-lp-scope]').forEach(function(scope) {
      if (scope.dataset.lpInitialized !== '1') setup(scope);
      else if (scope._lpObservedGrid !== scope.querySelector('.product-grid')) {
        watchGrid(scope);
        applyGlobal(scope);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',init);
  var outerObserver = new MutationObserver(function(){init();});
  outerObserver.observe(document.documentElement,{childList:true,subtree:true});
})();